import { useContext } from 'react';

// screen
import { PanelDataContext } from 'modules/context';

export const useTabsData = () => {
  const context = useContext(PanelDataContext);
  if (!context) {
    throw new Error('useTabsData must be used within a PanelDataContext');
  }
  return context;
};
